<template>
  <v-container fluid style="margin-top: -24px;">
    <v-row
        class="header-container"
        style="margin-left: -24px; margin-right: -24px;"
    >
      <slot name="content-cols"/>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: "Header"
  }
</script>

<style scoped>
  .header-container {
    background-image: url(./doe-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 168px;
  }
</style>